import ConfigService from './Config';
import BaseService from './Base';

class UnitsService extends BaseService {
  static endpoint = 'api/2.0/unit/';

  static async getWorkflow(action_item, params, skipLoading) {
    const filters = {...params, disable_pagination: true, action_item };
    const url = ConfigService.generateURL(this.endpoint + 'workflow/', filters);
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    try {
      const response = await window.fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'jwt ' + localStorage.getItem('jwt_token'),
          'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    } catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  }

  static async getMakeReadyBoard(filters, skipLoading) {
    const url = ConfigService.generateURL(this.endpoint + 'make-ready-board/', filters);
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    const response = await window.fetch(url, {
      method: 'GET',
      headers: {
        Authorization: 'jwt ' + localStorage.getItem('jwt_token'),
        'Time-Zone': jstz.determine().name()
      }
    });
    try {
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    } catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  }
}

export default UnitsService;